import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import withContext from '../../../lib/withContext';
import { Layout } from '../../blocks/Layout';
import { FiverrLogoLink } from '../../components/FiverrLogoLink';
import Navicon from '../../../components/Navicon';

interface Props {
    title?: string;
}

export const Lean = ({ title }: Props) => (
    <Layout>
        <Container
            hidden={{
                default: false,
                lg: true,
            }}
        >
            <Navicon />
        </Container>
        <FiverrLogoLink />
        {title && (
            <Heading as="h1" textAlign="center" size="h_xs" flexGrow="1">
                {title}
            </Heading>
        )}
    </Layout>
);

export default withContext(Lean);
